import './PublicDiscrimination.css';

export default function PublicDiscrimination() {

  return (
    <>
      <div className="pd-circles-section">
        <div className="pd-circle pd-large pd-blue">En la Calle</div>
        <div className="pd-circle pd-medium pd-dark-blue">Transporte público</div>
        <div className="pd-circle pd-medium pd-orange">Lugares públicos</div>
        <div className="pd-circle pd-small pd-light-blue">Sitio de Trabajo</div>
        <div className="pd-circle pd-small pd-red">Centro de Salud</div>
        <div className="pd-circle pd-small pd-purple">Institución Educativa</div>
      </div>
    </>
  );
}